export default (state, id) => {
  const {
    price: {
      current: { value: price }
    }
  } = state.savedItems.items.find(savedItem => savedItem.id === id);

  return price;
};
